import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <ToastProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Prerendered pages (server/scripts/prerender.js) and the index.html defaults carry head tags marked
// data-prerender. Once Helmet has written the page's own tags (data-rh), drop those so nothing is duplicated.
// Fallback: remove them anyway after 10 s (e.g. a page without <Seo>).
(function dropPrerenderHead() {
  if (typeof document === 'undefined' || !document.head.querySelector('[data-prerender]')) return;
  let done = false;
  let observer = null;
  let timer = null;
  const drop = () => {
    if (done) return;
    done = true;
    if (observer) observer.disconnect();
    clearTimeout(timer);
    document.head.querySelectorAll('[data-prerender]').forEach((el) => el.remove());
  };
  const helmetReady = () => Boolean(document.head.querySelector('[data-rh]'));
  if (helmetReady()) {
    drop();
    return;
  }
  if (typeof MutationObserver !== 'undefined') {
    observer = new MutationObserver(() => {
      if (helmetReady()) drop();
    });
    observer.observe(document.head, { childList: true });
  }
  timer = setTimeout(drop, 10000);
})();
